import { useState } from "react";
import { MailWarning } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export const VerifyBanner = () => {
  const { user } = useAuth();
  const [sent, setSent] = useState(false);
  if (!user || user.email_verified !== false) return null;
  const resend = async () => {
    await api.post("/auth/resend-verification", { email: user.email }).catch(() => {});
    setSent(true);
    toast.success("Email di conferma inviata di nuovo");
  };
  return (
    <div className="mb-6 flex flex-wrap items-center gap-3 rounded-2xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900" data-testid="verify-banner">
      <MailWarning className="h-5 w-5 shrink-0" />
      <p className="flex-1 min-w-[200px]">Conferma la tua email: abbiamo inviato un link a <strong>{user.email}</strong>. Hai 7 giorni per cliccarlo, poi servirà per accedere.</p>
      <button onClick={resend} disabled={sent} className="font-medium underline disabled:no-underline disabled:opacity-60" data-testid="verify-banner-resend">{sent ? "Inviata" : "Invia di nuovo"}</button>
    </div>
  );
};
